import { Link, usePage } from '@inertiajs/react'
import logo from "@/assets/logo.svg"
import api from "@/api"

export default function Nav() {
  const { url } = usePage();

  const isActive = (path) => {
    return url.startsWith(path) ? 'bg-blue-100 text-blue-700' : 'text-gray-500 hover:text-gray-700';
  };

  return (
    <nav className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center">
            <img src={logo} alt="Logo" style={{ height: "40px" }} />
            <span className="ml-3 text-xl font-bold text-gray-900 tracking-tight" style={{ fontFamily: 'PingFang SC, Microsoft YaHei, Arial, sans-serif' }}>
              奇绩校友招聘
            </span>
          </div>
          <div className="flex items-center space-x-4">
            <Link
              href={api.home.index.path()}
              className={`px-4 py-2 rounded-md text-sm font-medium ${isActive(api.home.index.path())}`}
            >
              上传职位描述
            </Link>

            {/*<Link
              href={api.candidates.index.path()}
              className={`px-4 py-2 rounded-md text-sm font-medium ${isActive(api.candidates.index.path())}`}
            >
              简历库
            </Link> */}
            <Link
              href={api.matches.index.path()}
              className={`px-4 py-2 rounded-md text-sm font-medium ${isActive(api.matches.index.path())}`}
            >
              匹配结果
            </Link>
            <Link
              method="delete"
              href={api.sessions.destroy.path({ id: "current" })}
              className={`px-4 py-2 rounded-md text-sm font-medium`}
            >
              退出登录
            </Link>
          </div>
        </div>
      </div>
    </nav>
  )
}
